import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ExclamationMarkTriangularSvgComponent } from '@uc/shared/svg';
import { getStateCourseSearchFilterPills } from '../../data-access/+store/course-search.selectors';
import { CourseSearchFilterPill } from '../../models/course-search-filter.models';
import { removeFilterPill } from '../../data-access/+store/course-search.actions';
import { CourseSearchFilterPillComponent } from '../course-search-filter-pill/course-search-filter-pill.component';
import { Meta } from '@angular/platform-browser';

@Component({
	selector: 'uc-course-search-no-result',
	templateUrl: './course-search-no-result.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ExclamationMarkTriangularSvgComponent, CourseSearchFilterPillComponent],
})
export class CourseSearchNoResultComponent implements OnInit {
	filterPills = this._store.selectSignal(getStateCourseSearchFilterPills);

	constructor(
		private _store: Store,
		private _meta: Meta,
	) {}

	ngOnInit(): void {
		this._meta.updateTag({ name: 'robots', content: 'noindex' });
	}

	onRemoveFilter(pill: CourseSearchFilterPill) {
		this._store.dispatch(removeFilterPill({ pill }));
	}
}
